import { Component } from '@angular/core';
import { NavBarComponent } from '../../shared/Components/nav-bar/nav-bar.component';
import { FooterComponent } from '../../shared/Components/footer/footer.component';
import { TranslatePipe } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-about-us',
  imports: [SharedModule],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.css',
})
export class AboutUsComponent {}
